/**
 * Hold reason copy — shared UI mapping for pay-run hold reasons.
 *
 * Pure UI strings. No schema, no writers. Imported by every surface that
 * renders a hold-reason chip (PayRunsCockpitPage, AccountingViewCockpit).
 * Single source of truth so a label/owner shift updates everywhere.
 */
import type { PayRunHoldReason } from "./getJobPayRun";

export const HOLD_REASON_LABEL: Record<PayRunHoldReason, string> = {
  failed_qa: "QA not passed",
  critical_issue_open: "Critical issue open",
  open_dispute: "Open dispute",
  holdback_required: "Holdback active",
  warranty_issue_open: "Warranty issue open",
  inspection_failed: "Inspection failed",
  field_add_requires_accounting_approval: "Field add needs accounting",
};

/**
 * Owner per hold reason — turns the chip from a status into a routable task.
 */
export const HOLD_REASON_OWNER: Record<PayRunHoldReason, string> = {
  failed_qa: "QA Lead",
  critical_issue_open: "Ops Manager",
  open_dispute: "Ops Manager",
  holdback_required: "Finance",
  warranty_issue_open: "Ops Manager",
  inspection_failed: "Permitting",
  field_add_requires_accounting_approval: "Accounting",
};
